import { INofshonPayment } from './../model/nofshon-payment';
import { FormControl } from '@angular/forms';
import { INirsham } from './../../nofesh/model/nirsham';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MenuHandler } from 'app/shared/menu-handler';
import { INofshonNirsham } from './../model/nofshon-nirsham';
import { NofshonimService } from '../nofshonim.service';
import { IAgeRanges } from './../model/age-ranges';
import { DateService } from 'app/shared/date.service';
import { ENofeshType } from '../../shared/enums/enofesh-type.enum';
import { INofesh } from '../../nofesh/model/nofesh';
import { INofshonNirshamim } from '../model/nofshon-nirshamim';
import { INofeshSelected } from '../../shared/interfaces/Inofesh-selected.interface';
import { ResultOfOperation } from '../../shared/model/result-of-operation.model';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { NofshonReservationTimerService } from 'app/shared/timer/nofshon-reservation-timer.service';
declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: './pirtey-nofshim.component.html',
    styleUrls: ['./pirtey-nofshim.component.css']
})

export class PirteyNofshimComponent implements OnInit, OnDestroy {
    constructor(
        private _activateRoute: ActivatedRoute,
        private _router: Router,
        private fb: FormBuilder,
        private _nofshonimService: NofshonimService,
        private _nofshonReservationTimerService: NofshonReservationTimerService,
        private ds: DateService,
        private _confirmDialogService: ConfirmService,
        private _confirmDialog: MatDialog,
        private _userMessagesService: UserMessagesService
    ) {
        this.form = this.fb.group({
            nirshamim: this.fb.array([])
        });

        MenuHandler.menuHandler($(".wiz_group"), $("#li_pirtey_nofshim"));
    }

    nofesh: INofesh;
    userSelectedNofesh: INofeshSelected;
    form: FormGroup;
    nofeshId: number = this._activateRoute.snapshot.params.id;
    age_ranges: IAgeRanges;
    identity_list: number[];
    no_zakaut_check: number = 0;
    nofeshType: number = ENofeshType.None;
    nofeshTypes: typeof ENofeshType = ENofeshType;
    nofesh_title: string;
    shem_prati: string;
    shem_mishpacha: string;
    nofshonPayment: INofshonPayment;
    errorMessage: string;
    fromTkufatNofesh: Date;
    pageVisited: boolean = false;
    get nirshamim() { return <FormArray>this.form.controls['nirshamim']; }
    currentTime: Date;
    private _timeoutSubscription: Subscription;

    ngOnInit() {
        window.scroll(0, 0);

        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if (nofashim != null && nofashim != undefined) {
            this.initNofesh(nofashim);
        }
        else {
            // TODO: get all nofashim from API
            // inside subscribe, init nofesh (line below)
            //this.initNofesh(nofashim);
        }

        let nirshamim: INofshonNirshamim = JSON.parse(sessionStorage.getItem("nofshon-nirshamim"));
        if (nirshamim === null || nirshamim.nirshamim === null || nirshamim.nirshamim.length === 0) {
            this._nofshonimService.getPirteyNofshim(this.nofeshId).subscribe((response: INofshonNirsham[]) => {
                if (response === null) {
                    this._userMessagesService.setErrorMessage("אירעה שגיאה בטעינת הנתונים. נא לעבור לדף רשימת היעדים ולבצע את התהליך מחדש");
                    window.scroll(0, 0);
                    return;
                }

                nirshamim = { nirshamim: response };
                sessionStorage.setItem("nofshon-nirshamim", JSON.stringify(nirshamim));
                this.generateNirshamimList(response);
            }, error => console.log(error));
        }
        else {
            this.generateNirshamimList(nirshamim.nirshamim);
        }

        // Check if this page was already visited (visited considered as long as sessionStorage not erased).
        this.pageVisited = Boolean(JSON.parse(sessionStorage.getItem(`pirteyNofshimVisited_${this.nofeshId}`)));

        this._nofshonimService.getNofshonPayment(this.nofeshId).subscribe(res => {
            this.nofshonPayment = res.nofshonPayment;
        })

        this.userSelectedNofesh = JSON.parse(sessionStorage.getItem("userSelectedNofesh"));
        if (this.userSelectedNofesh) {
            this.shem_prati = this.userSelectedNofesh.shem_prati;
            this.shem_mishpacha = this.userSelectedNofesh.shem_mishpacha;

            if (!this.userSelectedNofesh.isReservationCompleted && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
                const reservationExpiration = this._nofshonReservationTimerService.getReservationExpiration(this.userSelectedNofesh.moed_rishum);
                const isExpired = this._nofshonReservationTimerService.checkIfTimerTimedOut(reservationExpiration);
                if (isExpired) {
                    console.log("Pirtey nofshim - navigating to home on timeout");
                    this.navigateToNofeshPage();
                    return;
                }
                else {
                    if ("startTimer" in sessionStorage) {
                        sessionStorage.removeItem("startTimer")
                        this._nofshonReservationTimerService.startTimer();
                    }
                    else {
                        this._nofshonReservationTimerService.resumeTimer(reservationExpiration);
                    }
                    this._timeoutSubscription = this._nofshonReservationTimerService.timerTimeout$.subscribe((timeout: boolean) => {
                        console.log("Pirtey nofshim - timer notified. Is timeout?", timeout);
                        if (timeout) {
                            console.log("Pirtey nofshim - navigating to home on resumed timeout");
                            this.navigateToNofeshPage();
                        }
                    });
                }
            }
        }
    }

    navigateToNofeshPage(): void {
        this._router.navigate(["/nofesh"]);
    }

    ngOnDestroy() {
        // An indicator to determine if this page was visited already.
        // We will set to true when leaving this page.
        sessionStorage.setItem(`pirteyNofshimVisited_${this.nofeshId}`, "true");
        if (this.userSelectedNofesh && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
            if (this._timeoutSubscription) {
                this._timeoutSubscription.unsubscribe();
            }
        }
    }

    initNofesh(nofashim: INofesh[]): void {
        this.nofesh = nofashim.find(t => t.id_nofesh == this.nofeshId);
        if (this.nofesh) {
            this.age_ranges = {
                child_min_age: this.nofesh.child_min_age,
                child_max_age: this.nofesh.child_max_age
            };
            this.no_zakaut_check = this.nofesh.no_zakaut_check;
            this.nofeshType = this.nofesh.nofeshType;
            this.nofesh_title = this.nofesh.nofeshTitle;
            this.fromTkufatNofesh = this.nofesh.fromTkufatNofesh;
        }
    }


    addNirsham(header: string, nirsham: INofshonNirsham) {
        let nirshamimArray = this.form.get('nirshamim') as FormArray;
        let nirshamFormGroup: FormGroup = this.initNirsham(header, nirsham);
        nirshamimArray.push(nirshamFormGroup);
    }

    initNirsham(header: string, nirsham: INofshonNirsham): FormGroup {
        let m_cheder: number;
        if (nirsham != null) {
            m_cheder = nirsham.ms_cheder;
        }

        let n: FormGroup;
        if (nirsham.ms_zehut == 0) {
            // Partial object to INofshonNirsham because some properties are not mandatory (like darkon or phone) and will be added only in certain nofesh types
            n = this.fb.group({
                ms_zehut_mazmin: [nirsham.ms_zehut_mazmin, Validators.required],
                ms_zehut: ['', Validators.required],
                tr_leida: ['', Validators.required],
                shem_prati: ['', Validators.required],
                shem_mishpacha: ['', Validators.required],
                gender: ['', Validators.required],
                header: [header],
                ms_cheder: m_cheder,
                is_amit: nirsham.is_amit,
                is_nilve: nirsham.is_nilve,
                is_yeled: nirsham.is_yeled,
                is_tinok: nirsham.is_tinok,
                id_nofesh: nirsham.id_nofesh,
                nofesh_type: nirsham.nofesh_type
            });

            if (nirsham.is_amit > 0) {
                // Add required phone control to amit.
                n.addControl("phone", new FormControl("", Validators.required));
            }
            else if (nirsham.is_nilve > 0) {
                // Add optional phone control to nilve.
                n.addControl("phone", new FormControl(""));
            }

            if (this.nofeshType >= ENofeshType.NofeshChul) {
                n.addControl('ms_darkon', new FormControl('', Validators.required));
                n.addControl('tr_tokef_darkon', new FormControl('', Validators.required));
                n.addControl('shem_prati_loazi', new FormControl('', Validators.required));
                n.addControl('shem_mishpacha_loazi', new FormControl('', Validators.required));
            }
        }
        else {
            let tr_leida = nirsham.tr_leida != null ? new Date(nirsham.tr_leida) : null;
            let tr_tokef_darkon = nirsham.tr_tokef_darkon != null ? new Date(nirsham.tr_tokef_darkon) : null;

            // Partial object to INofshonNirsham because some properties are not mandatory (like darkon or phone)
            n = this.fb.group({
                ms_zehut_mazmin: [nirsham.ms_zehut_mazmin],
                ms_zehut: [nirsham.ms_zehut, Validators.required],
                tr_leida: [nirsham.tr_leida, Validators.required],
                shem_prati: [nirsham.shem_prati, Validators.required],
                shem_mishpacha: [nirsham.shem_mishpacha, Validators.required],
                gender: [nirsham.gender, Validators.required],
                header: [header],
                ms_cheder: m_cheder,
                is_amit: nirsham.is_amit,
                is_nilve: nirsham.is_nilve,
                is_yeled: nirsham.is_yeled,
                is_tinok: nirsham.is_tinok,
                id_nofesh: nirsham.id_nofesh,
                nofesh_type: nirsham.nofesh_type
            });

            if (nirsham.is_amit > 0) {
                // Add required phone control to amit.
                n.addControl("phone", new FormControl(nirsham.phone, Validators.required));
            }
            else if (nirsham.is_nilve > 0) {
                // Add phone control to nilve.
                n.addControl("phone", new FormControl(nirsham.phone));
            }

            if (this.nofeshType >= ENofeshType.NofeshChul) {
                n.addControl('ms_darkon', new FormControl(nirsham.ms_darkon, Validators.required));
                n.addControl('tr_tokef_darkon', new FormControl(nirsham.tr_tokef_darkon, Validators.required));
                n.addControl('shem_prati_loazi', new FormControl(nirsham.shem_prati_loazi, Validators.required));
                n.addControl('shem_mishpacha_loazi', new FormControl(nirsham.shem_mishpacha_loazi, Validators.required));
            }

            if (tr_leida) {
                n.patchValue({
                    tr_leida: new Date(tr_leida.getFullYear(), tr_leida.getMonth(), tr_leida.getDate())
                });
            }

            if (this.nofeshType >= ENofeshType.NofeshChul && tr_tokef_darkon) {
                n.patchValue({
                    tr_tokef_darkon: new Date(tr_tokef_darkon.getFullYear(), tr_tokef_darkon.getMonth(), tr_tokef_darkon.getDate())
                });
            }
        }
        return n;
    }

    onSubmit() {
        this.errorMessage = null;

        // Set dates to UTC
        for (let i = 0; i < this.form.value.nirshamim.length; i++) {
            let birthDate: Date = this.form.value.nirshamim[i].tr_leida;
            this.form.value.nirshamim[i].tr_leida = this.ds.setUTCDate(birthDate);
            if (this.nofeshType >= ENofeshType.NofeshChul) {
                let tokefDarkon: Date = this.form.value.nirshamim[i].tr_tokef_darkon;
                this.form.value.nirshamim[i].tr_tokef_darkon = this.ds.setUTCDate(tokefDarkon);
            }
        }


        //  
        // nofshon-nirshamim is of type INofshonNirshamim and here it overriden to a different object in which
        // every item is partial to INofshonNirsham.
        // TODO: Iterate over the form.value and set it's values to current nofshon-nirshamim object,
        // then save it to sessionStorage. 
        // This will ensure object consistency.
        sessionStorage.setItem('nofshon-nirshamim', JSON.stringify(this.form.value));

        this._nofshonimService.savePirteyNofshim(this.form.value).subscribe((response: ResultOfOperation<object>) => {
            if (response.isSuccess) {
                switch (this.nofeshType) {
                    case ENofeshType.NofeshPnim:
                    case ENofeshType.MeurganimPnim:
                        this._router.navigate(['nofesh-pnim/pirtey-tashlum/' + this.nofeshId]);
                        break;
                    case ENofeshType.NofeshChul:
                        this._router.navigate(['nofshonim-chul/pirtey-tashlum/' + this.nofeshId]);
                        break;
                    case ENofeshType.MishpachotChul:
                        this._router.navigate(['mishpachot-chul/pirtey-tashlum/' + this.nofeshId]);
                        break;
                }
            }
            else {
                this.errorMessage = response.message;
            }
        }, error => {
            this.errorMessage = "אירעה שגיאה";
        });
    }

    setParseDate(m): Date {
        if (m) {
            return new Date(Date.UTC(m.year, m.month - 1, m.day));
        }

        return null;
    }

    generateNirshamimList(nirshamim: INofshonNirsham[]) {
        let amitim = nirshamim.filter(t => t.is_amit > 0);
        if (amitim != null && amitim != undefined && amitim.length > 0) {
            for (let i = 0; i < amitim.length; i++) {
                this.addNirsham(`עמית ${i + 1}`, amitim[i]);
            }

        }

        let nilvim = nirshamim.filter(t => t.is_nilve > 0);
        if (nilvim != null && nilvim != undefined && nilvim.length > 0) {
            for (let i = 0; i < nilvim.length; i++) {
                this.addNirsham(`נלווה ${i + 1}`, nilvim[i]);
            }

        }

        let yeladim = nirshamim.filter(t => t.is_yeled > 0);
        if (yeladim != null && yeladim != undefined && yeladim.length > 0) {
            for (let i = 0; i < yeladim.length; i++) {
                this.addNirsham(`ילד ${i + 1}`, yeladim[i]);
            }

        }

        let tinokot = nirshamim.filter(t => t.is_tinok > 0);
        if (tinokot != null && tinokot != undefined && tinokot.length > 0) {
            for (let i = 0; i < tinokot.length; i++) {
                this.addNirsham(`תינוק ${i + 1}`, tinokot[i]);
            }

        }
    }

    redirectToLogin() {
        this._router.navigate(['/login'], { queryParams: { nav: 'nofesh' } });
    }

    cancelReservation(): void {
        if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(this.userSelectedNofesh.moed_rishum)) {
            this._nofshonReservationTimerService.stopTimer();
            this._nofshonReservationTimerService.hideTimer();
            console.log("Pirtey nofshim - cancel reservation by user on minimal timer time. Timer is stopped");
        }



        this._nofshonimService.cancelNofshonReservation(this.nofeshId).subscribe(() => {
            //this._nofshonimService.cancelNofshonReservation().subscribe(() => {
            this._nofshonimService.clearSessionOnCancelReservation(this.nofeshId);
            if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
                this._nofshonReservationTimerService.stopTimer();
                this._nofshonReservationTimerService.hideTimer();
                console.log("Pirtey nofshim - cancel reservation by user. Timer is stopped");
            }

            const message = "ההזמנה בוטלה בהצלחה";
            this._userMessagesService.showSnackBarSuccessMessage(message, null, this._userMessagesService.clearAll.bind(this._userMessagesService));
            this._userMessagesService.setSuccessMessage(message);
            this.navigateToNofeshPage();
        });
    }

    showConfirmCancelDialog() {
        let data;
        if (this.userSelectedNofesh.isReservationCompleted) {
            data = {
                title: "ביטול הזמנה",
                content: [
                    "האם לבטל את ההזמנה?",
                    "",
                    "עלות ביטול הזמנה בעמותה - 80 ₪ לנוסע.",
                    "לא ייגבה תשלום על ביטול נופש בהמתנה."
                ],
                confirmButtonText: "כן, אני רוצה לבטל",
                declineButtonText: "סגור"
            }
        }
        else {
            data = {
                title: "ביטול הזמנה",
                content: ["האם לבטל את ההזמנה?"]
            }
        }

        const dialogRef = this._confirmDialog.open(ConfirmDialogComponent, {
            width: "600px",
            data,
            hasBackdrop: true,
            disableClose: true,
            restoreFocus: true,
            closeOnNavigation: true
        });

        const dialogSubscription = this._confirmDialogService.confirm$.subscribe(() => {
            dialogRef.close();
            dialogSubscription.unsubscribe();
            this.cancelReservation();
        });

    }
}
